@if (visibility) {
  <div class="tag-popover-content">
    <div class="tag-popover" role="dialog" aria-label="Etiquetas">
      <div class="tag-panel">
        <h2 class="tag-panel__title">Etiquetas</h2>
        @if (!addTagFlag) {
          @if (tags.length > 0) {
            <ul class="tag-list">
              @for (tag of tags; track tag) {
                <li>
                  <div class="tag-preview tag-list-item" [style.background-color]="tag.color"
                    [ngStyle]="{'--after-background-color': tag.color}" (click)="selectTagToEdit(tag)"
                    title="Editar etiqueta">
                    {{tag.name}}
                  </div>
                  <button type="button" class="delete-tag-btn" title="Eliminar etiqueta {{ tag.name }}"
                    [attr.aria-label]="'Eliminar etiqueta ' + tag.name" (click)="validateTasks(tag.id)">
                    <img src="../../../assets/icons/common/delete-black.png" alt="" />
                  </button>
                </li>
              }
            </ul>
          } @else {
            <p class="tag-panel__empty">Todavía no hay etiquetas. Creá la primera para clasificar tareas.</p>
          }
          <div class="tag-panel__actions">
            <button class="add-tag-btn" type="button" (click)="addTagFlag = true" mat-stroked-button>
              + Agregar etiqueta
            </button>
          </div>
        }
        <!-- Add Filter-->
        <form [formGroup]="tagForm">
          @if (addTagFlag) {
            <div class="tag-form">
              <div class="custom-fill-input">
                <img src="../../../assets/icons/common/tag.png" alt="">
                <input placeholder="Nombre" formControlName="name"
                  maxlength="14"/>
              </div>
              <div class="tag-preview" [style.background-color]="color"
                [ngStyle]="{'--after-background-color': color}">
                Nombra la etiqueta
              </div>
              <div class="custom-fill-input">
                <img src="../../../assets/icons/common/color-palette.png" alt="">
                <input [value]="color" [(colorPicker)]="color" placeholder="Color" />
              </div>
              <label class="color-selector-label">Seleccioná un color</label>
            </div>
          }
        </form>
        @if (addTagFlag) {
          <div class="tag-panel__actions">
            <button (click)="cancel()" type="button" mat-stroked-button class="cancel-add-tag-btn">
              Cancelar
            </button>
            <button (click)="saveTag()" type="button" mat-flat-button class="save-add-tag-btn"
              [disabled]="disabled()">
              {{tagForm.controls.id.value ? 'Editar' : 'Crear'}} etiqueta
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
